import { Route, Routes } from "react-router-dom";
import WebOrderPage from "../features/web-order/pages/WebOrderPage";
import LandingPage from "../features/landing/pages/LandingPage";
import PublicOrderTrackingPage from "../features/tracking/pages/PublicOrderTrackingPage";

// This app serves a single seller's storefront — WHICH seller is baked into
// this deployment's own .env (REACT_APP_SELLER_ID/REACT_APP_STOREFRONT_API_KEY,
// see webOrderApi.js), not the URL. WhatsApp CTA_URL links now just carry the
// customer's phone: {{store_domain}}/order?cp={{customer_phone}} — see
// chatflow-engine.service.ts's resolveTemplate for where sellers configure
// that link, and StorefrontApiKeyGuard for how the headers get validated.
export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/order" element={<WebOrderPage />} />
      <Route path="/track/:orderId" element={<PublicOrderTrackingPage />} />
      <Route
        path="*"
        element={
          <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
            <div className="max-w-sm w-full bg-white rounded-2xl border border-slate-200 shadow-lg p-6 text-center space-y-2">
              <h1 className="text-lg font-extrabold text-slate-900">Page not found</h1>
              <p className="text-sm text-slate-500">This link isn't valid. Please check the link and try again.</p>
            </div>
          </div>
        }
      />
    </Routes>
  );
}
